// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__23ayR","bigColWidth":"Table_bigColWidth__fwJX0","biggerColWidth":"Table_biggerColWidth__XlsOY","row":"Table_row__2OWvt","col":"Table_col__3yOU6"};